<template lang="html">
      <div class="user">
        <div class="podkategorije">
            <ul>
              <li v-for="pod in podkategorije" :class="{active3:product.podkat == pod.pod_id}" @click="getall(pod.pod_id)" v-if="pod.kat_id == katid">{{pod.pod_naziv}} </li>
            </ul>
        </div>
        <span @click="noviproizvod = false" v-if="seepro && noviproizvod" > <i  title="Dodaj proizvod" class="fas fa-arrow-left"></i> Nazad</span>
        <div class="proizvod" v-if="seepro && !noviproizvod && !edit">
          <span v-if="product.podkat !=''" @click="noviproizvod = true ">Dodaj proizvod <i  title="Dodaj proizvod" class="fas fa-plus-square"></i></span>
          <br>
          <table v-if="product.podkat !=''" v-for="all in allpro">
            <tr>
              <th style="width:40%">
                <i style="font-size: 16px;float: left" title="Obrisi proizvod" @click="obrisipro(all.pro_id)" class="far fa-trash-alt"></i> &nbsp
                <i style="font-size: 16px;float: left; margin-left: 10px;" title="Izmeni proizvod" @click="izmeni(all.pro_id)" class="fas fa-pencil-alt"></i>
                &nbsp{{all.pro_name}}</th>
              <th style="width:30%">Pakovanje</th>
              <th style="width:20%">Cena</th>
              <th style="width:10%">
              <i @click="ubacipak(all.pro_name,all.pro_id)" title="Dodaj pakovanje" class="fas fa-plus-square"></i>
                <!-- <button type="button" name="button" @click="ubacipak(all.pro_name,all.pro_id)" >Pak. ++ </button> -->
               </th>
            </tr>
             <tr v-for="pak in allpak" v-show="pak.pro_id == all.pro_id">
              <td style="width:40%">&nbsp</td>
              <td style="width:30%">{{pak.pak_naziv}}</td>
              <td style="width:20%">{{pak.pro_cena}} rsd</td>
              <td style="width:10%">
                <!-- <i title="Izmeni pakovanje" @click="izmenipak()" class="fas fa-pencil-alt"></i> -->
              <i title="Obrisi pakovanje" @click="obrisipak(pak.vez_id)" class="far fa-trash-alt"></i></td>
            </tr>
        </table>
        <div   class="update" v-show="funkcija == 'insertpakovanje'">
            <button type="button" style="position:absolute; top:10px; right:10px" name="button" @click="funkcija=''"> X </button>
            <br>
            <p>Proizvod: <span>{{proizvodime}}</span> </p>
            <label for="">  Odaberi pakovanje:</label>
              <select v-model="pakovanje">
                <option value=""  selected="selected" disabled="disabled" style="display: none" >Pakovanje</option>
                <option  v-for="(pak,index) in pak" :value="index">{{pak.pak_naziv}}</option>
              </select>
              <label for="">Unesi cenu:</label>
              <input type="text"  min="0" name="" value="0.00" v-model="cena" placeholder="Unesite cenu">
              <button type="button" style="position:absolute; bottom:10px; right:10px" name="button" @click="dodajpak(pak.pak_naziv)">Ubaci</button>
        </div>
        </div>


        <div class="" v-show="noviproizvod">
        <div class=""  style="display: inline-grid;background: white;grid-template-columns: 70% 30%;margin-top:10px">
        <div class="foto">
          <div class="avatar-upload" v-for="(n,index) in image" :id="'pocetna'+index">
              <p style="position:absolute">{{index+1}}. Sl. <span v-if="index == 0"> - Početna</span> </p><br>
              <img style="width: 150px;margin-bottom:10px;float: left;" v-if="n.url2":src="n.url2" alt="">
              <croppa v-if="!n.url2" v-model="n.croppa"
              placeholder="Odaberite fotografiju"
              :placeholder-font-size="14"
              :disabled="false"
              canvas-color="white"
              :prevent-white-space="false"
            :accept="'.jpeg, .jpg, .png'"
             @file-type-mismatch="onFileTypeMismatch"
             @file-size-exceed="onFileSizeExceed"
              @file-choose=""
              @image-remove="handleImageRemove(index)"
              initial-size="cover"
              @init=""
              @new-image-drawn="handleNewImage(index)"
              placeholder-color="#4565db"
              :canvas-width='image[index].sirina'
              :canvas-height='image[index].visina'
              :width='image[index].sirina'
              :height='image[index].visina'
              :zoom-speed="10"
              :remove-button-size="20"
              :show-loading="true"
              :loading-size="50"
              @move="handleChange(index)"
              @zoom="handleChange(index)"
              >
              </croppa>
              <i style="float:right" class="fas fa-portrait" @click="image[index].sirina = 150"></i>
              <i class="far fa-image" @click="image[index].sirina = 300"></i>
              <i class="fas fa-trash-alt" style="right:8px" v-if="n.url2" @click="obrisisliku(index)" title="Obrisi"></i>
              <i class="fas fa-sync-alt" style="left:8px" v-if="n.is && !n.url2" @click="n.croppa.rotate(-1)" title="Rotiraj"></i>
              <i class="fas fa-check" style="right:8px" v-show="n.is && !n.url2" @click="sacuvajsliku(index)" title="Sačuvaj"></i>


            </div>
        </div>

        <div class="naziv">
            <label for="">Naziv artikla:</label>
            <input type="text" name="" value="" v-model="product.naziv" placeholder="Unesite naziv artikla">
              <label>Odaberite proizvodjaca:</label>
                <select  v-model="product.brand" >
                   <option value=""  selected="selected" disabled="disabled" style="display: none" >Odaberite proizvodjaca</option>
                   <option  v-for="bra in brand" :value="bra.bra_id">{{bra.bra_naziv}}</option>
                 </select>
          <label for="">  Odaberi pakovanje:</label>
            <select v-model="pakovanje">
              <option value=""  selected="selected" disabled="disabled" style="display: none" >Odaberite vrstu</option>
              <option  v-for="(pak,index) in pak" :value="index">{{pak.pak_naziv}}</option>
            </select>
            <label for="">Unesi cenu:</label>
            <input type="number"  min="0" name="" value="0.00" v-model="cena" placeholder="Unesite cenu">
            <button type="button" name="button" style="float:right" @click="dodajcenu()">Ubaci</button>
          <table v-for="(c,index) in cene">
            <tr>
              <td>{{c.pakovanje}} </td>
              <td>{{c.cena}} rsd</td>
              <td><i @click="move(index)" class="far fa-trash-alt"></i></td>
            </tr>

          </table>
        </div>
      </div>
        <div id="editor">
         <vue-editor useCustomImageHandler v-model="product.opis"></vue-editor>
       </div>
            {{err}}

           <h2>{{product.opis}}</h2>
           <button type="button" style="float:right; margin-top:20px" @click="posalji()" name="button">Postavi oglas</button>
        </div>
        <izmeni v-if="edit"></izmeni>

          </div>
</template>

<script>
   import Vue from "vue";
import izmeni from '@/components/izmeni'
import { VueEditor } from "vue2-editor";
import imageCompression from 'browser-image-compression'
import {mapGetters, mapActions, mapMutations} from 'vuex'


export default {

  components: {
    izmeni,
   imageCompression,
   VueEditor
 },
  data () {
    return {
      noviproizvod:false,
      proizvodime:"",
      funkcija:"",
      katid:this.$route.params.katid,
      seepro:false,
      detalji:null,
      putanja:this.$route.params.kategorije,
      htmlForEditor: "",
      pakovanje:"",
      cena:"",
      proid:"",
      image:[
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
          {'url':"", url2:'', position:"",sirina:200, visina:150, do:false, 'is':false, croppa:{} },
        ],
      cene:[],
      product:{
        naziv:"",
        podkat:"",
        brand:"",
        opis:""
      },
        subindex:"",
        catindex:"",
        genindex:"",
        err:null,
        objslike:[null, null, null, null, null,null,null,null,null]



    }
  },
created(){
  if(this.$route.params.katid){
    this.getall(this.katid)

  }
  this.product={
    naziv:"",
    podkat:"",
    brand:"",
    opis:""
  },
  this.product.podkat=''
},
watch:{
  $route:function(to, from){
    this.putanja = this.$route.params.pozicija
    this.katid = this.$route.params.katid
    this.product.podkat=''
    this.noviproizvod=false
  }
},
computed:{
          ...mapGetters([
            'kategorije',
            'podkategorije',
            'brand',
            'pro',
            'allpro',
            'allpak',
            'pak',
            'edit'
          ]),
},
  methods:{
    async izmeni(id){
      await this.geteditpro(id).then(response=>{
        this.setedit(true)
      })

    },
    handleChange(i){
    this.image[i].do = true
  },
  obrisisliku(i){
    this.image[i].url2 = ""
    this.image[i].url = ""
    this.objslike[i] = null
    this.image[i].is = false
    console.log(this.objslike);
  },
  sacuvajsliku(i){
      this.image[i].url2 = this.image[i].croppa.generateDataUrl('image/jpeg', 0.9)
      this.image[i].croppa.generateBlob((blob) => {
                this.objslike[i]= blob
            }, 'image/jpeg', 0.9)
      this.image[i].do = false
  },

  handleImageRemove(i){
    this.image[i].blob = null
    this.image[i].is = false
  },
  handleNewImage(i){
    this.image[i].is = true
    this.image[i].croppa.generateBlob((blob) => {
              this.objslike[i]= blob
          }, 'image/jpeg', 0.9  )

  },

 onFileTypeMismatch (index) {
   alert('Ne poznat format. Molimo Vas odaberite .jpg , .jpeg ili .png format.')
   return this.slike[index].is=false
 },
 onFileSizeExceed (index) {
   alert('Velicina fajla je prevelika. Molimo Vas odaberite sliku manju od 3Mb.')
   return this.slike[index].is=false
 },
    move(index){
      this.cene.splice(index , 1)
      return this.cene
    },
    obrisipro(id){
      var potrvda = confirm('Da li sigurno zelite da obrisete proizvod')
      if(!potrvda){
        return
      }
      var obj=[]
      obj.push(id)
      obj.push(this.product.podkat)
      this.deletepro(obj)
    },
    obrisipak(id){
      var potrvda = confirm('Da li sigurno zelite da obrisete pakovanje')
      if(!potrvda){
        return
      }
      var obj=[]
      obj.push(id)
      obj.push(this.product.podkat)
      this.deletepak(obj)
    },
    dodajpak(ime){
      var obj=[]
      obj.push(this.proid)
      obj.push(this.pak[this.pakovanje].pak_id)
      obj.push(this.pak[this.pakovanje].pak_naziv)
      obj.push(this.cena)
      obj.push(this.product.podkat)
      this.insertpak(obj)
    },
    ubacipak(name, id){
      this.funkcija = 'insertpakovanje'
      this.proizvodime = name
      this.proid = id
    },
    preventClose(e){
      e.stopPropagation()
    },
    getall(id){
      this.noviproizvod = false
      this.product.podkat = id
      this.seepro = true
      this.getallpro(id)
    },
    put(naziv){
      this.putanja = naziv
    },
    setTwoNumberDecimal(el) {
        this.cena = parseFloat(el.value).toFixed(2);
    },
    async dodajcenu(){
      var obj={}
      obj.pakovanje = this.pak[this.pakovanje].pak_naziv
      obj.cena = this.cena
      obj.id = this.pak[this.pakovanje].pak_id
      console.log(obj);
      try {
        this.cene.push(obj)

      } catch (e) {

      } finally {
        this.pakovanje = null
        this.cena = null
      }
    },
    async posalji () {
      this.err = null
      const areAllFieldsFilledIn = Object
        .keys(this.product)
        .every(key => !!this.product[key])
      if (!areAllFieldsFilledIn) {
        this.err = 'Molim Vas popunite sva obavezna polja'
        return
      }
      if(!this.objslike[0]){
        this.err = 'Molim ubacite glavnu sliku => 1.slika'
        return
      }
      try {

        var ce = JSON.stringify(this.cene)
        var obj=[]
        obj.push(this.product)
        obj.push(this.objslike)
        obj.push(ce)
        this.putproduct(obj)
        this.noviproizvod = false
        this.cene = ""
        this.pakovanje = ""
        this.product.naziv = ""
        this.product.brand = ""
        this.product.opis = ""
        // var img = $('<img>').attr('src', '');
        // for (var i = 0; i < this.slike.length; i++) {
        //   this.objslike[i].file=null
        //   $('#'+this.slike[i].name).html(img);
        // }
        this.getall(this.product.podkat)

      } catch (err) {
        console.log(err)
      }
    },

    async addImg(e,id,index){
      let droppedFiles = e.target.files || e.dataTransfer.files;
      const imageFile = droppedFiles[0];
      var reader = new FileReader();
       reader.onload = function(e) {
         var img = $('<img>').attr('src', e.target.result);
           $('#'+id).html(img);
       }
       reader.readAsDataURL(imageFile)
       var options = {
         maxSizeMB: 0.5,
         maxWidthOrHeight: 350,
         useWebWorker: true
       }
       try {
         const compressedFile = await imageCompression(imageFile, options);
         console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
         console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
           this.slike[index].file = compressedFile
           this.slike[index].is = true

       } catch (error) {
         console.log(error);
       }
    },
    removeImg(id,index){
        this.slike[index].file = ''
        this.slike[index].is = false
        var img = $('<img>').attr('src', '');
          $('#'+id).html(img);

    },

  ...mapMutations([
      'setedit'

  ]),
  ...mapActions([
    'geteditpro',
    'getpro',
    'getallpro',
    'putproduct',
    'getproizvodi',
    'getsinglpk',
    'getbrand',
    'getpro',
    'getpak',
    'insertpak',
    'deletepak',
    'deletepro'

  ]),
},
mounted(){
    this.getproizvodi()
    this.getbrand()
    this.getpak()

    // Add the onclick listeners.
    // details.forEach((targetDetail) => {
    //   targetDetail.addEventListener("click", () => {
    //     details.forEach((detail) => {
    //       console.log(detail);
    //       if (detail !== targetDetail) {
    //         detail.removeAttribute("open");
    //       }
    //     });
    //   });
    // });

  }


}
</script>

<style lang="css" scoped>
details .checkbox:focus{
  margin-right: 10px
}
details[open] summary ~ * {
  animation: open .3s ease-in-out;
}
details summary::-webkit-details-marker {
  line-height: 100%;
  margin: 10px  10px 0 5px;
  color: var(--zelenoplava);
  width: 10px;
  height: 10px
}
details span{
  color: var(--zelenoplava);
}
summary:hover{
  cursor: pointer;
  color: var(--zelena)
}
summary:hover span{
  color: var(--narandzasta);
}

summary{
  outline:none;
}
/* summary:hover{
  color: white;
  background: var(--zelenoplava);
  cursor: pointer;
} */
summary:hover::-webkit-details-marker{
  color: var(--narandzasta);
}
</style>



// WEBPACK FOOTER //
// src/components/proizvodiadmin.vue